import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import JobsTable from './jdTable';
import CandidateFollowup from './Cc';
import { useAuth } from '../../Context/AuthContext';
import { getApiUrl } from '../../utils/api';
import { Button } from '@/Components/ui/button';
import { Briefcase, Plus } from 'lucide-react';

function AllJob({ selectedCompany, setActiveMain, setSelectedJob }) {
    const navigate = useNavigate();
    const location = useLocation();
    const { isSuperAdmin, isAdminAuthenticated } = useAuth();
    const isNormalAdmin = isAdminAuthenticated && !isSuperAdmin;

    const jobID = new URLSearchParams(location.search).get("jobID");
    const companyID = new URLSearchParams(location.search).get("companyID");
    const [companyEmail, setCompanyEmail] = useState(selectedCompany?.email || "");
    const [selectedJobId, setSelectedJobId] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const [showPopup, setShowPopup] = useState(false);

    // If selectedCompany already has the email (passed from Content.jsx), use it directly.
    // Only fetch from API when it's missing — skips 1-2 serial round-trips.
    useEffect(() => {
        if (selectedCompany?.email) {
            setCompanyEmail(selectedCompany.email);
            return;
        }
        if (!companyID) return;
        fetch(getApiUrl(`/api/get_company_by_ID?companyID=${encodeURIComponent(companyID)}`), {
            method: "GET", credentials: "include",
        })
            .then(r => r.ok ? r.json() : null)
            .then(data => { if (data?.email) setCompanyEmail(data.email); })
            .catch(err => console.error("Error fetching company:", err));
    }, [companyID, selectedCompany]);

    const toggleDropdown = (e) => {
        e.stopPropagation();
        setShowDropdown(prev => !prev);
    };

    const handleOutsideClick = (e) => {
        if (!e.target.closest('.admin-viewjobs-postjob-wrapper')) {
            setShowDropdown(false);
        }
    };

    const handleCreateJD = () => {
        navigate(`/create-JD?companyID=${encodeURIComponent(companyID)}`);
        setShowDropdown(false);
    };

    const handleGenerateJD = () => {
        navigate(`/generate-jd?companyID=${encodeURIComponent(companyID)}`);
        setShowDropdown(false);
    };

    const handleUploadJD = () => {
        navigate(`/upload-JD?companyID=${encodeURIComponent(companyID)}`);
        setShowDropdown(false);
    };

    const handleClosePopup = () => {
        setShowPopup(false);
    };

    useEffect(() => {
        document.addEventListener('click', handleOutsideClick);
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, []);

    const handleJobSelect = (jobId) => {
        setSelectedJobId(jobId);
    };

    return (
        <>
            <div className="p-6">
                        <div className="bg-white rounded-xl shadow-sm border border-slate-100 p-6">
                                <div className={isNormalAdmin ? "flex items-center justify-between mb-5 bg-slate-50 p-3 rounded-lg border border-dashed border-slate-300" : "flex items-center justify-between mb-5"}>
                                    <div className="flex items-center gap-2 px-4 py-3 font-semibold text-slate-800">
                                        <Briefcase className="w-5 h-5 text-slate-600" />
                                        <span className="text-xl font-bold text-slate-800">{isNormalAdmin ? 'My Assigned Jobs' : 'All Jobs'}</span>
                                        {isNormalAdmin && (
                                            <span className="text-xs text-slate-400 italic ml-2">(Read Only)</span>
                                        )}
                                    </div>

                                    {!isNormalAdmin && (
                                        <div className="admin-viewjobs-postjob-wrapper relative" onClick={(e) => e.stopPropagation()}>
                                            <Button
                                                className="bg-[#5d52d9] hover:bg-[#7c6dee] text-white flex items-center gap-2"
                                                onClick={toggleDropdown}
                                            >
                                                <Plus className="w-4 h-4" />
                                                Post Job ▾
                                            </Button>

                                            {showDropdown && (
                                                <div className="absolute right-0 top-full mt-2 bg-white rounded-xl shadow-lg border border-slate-100 z-50 min-w-[180px] overflow-hidden">
                                                    <button className="block w-full text-left px-4 py-3 text-sm text-slate-700 hover:bg-slate-50 border-none bg-transparent cursor-pointer transition-colors" onClick={handleCreateJD}>
                                                        Create JD
                                                    </button>
                                                    <button className="block w-full text-left px-4 py-3 text-sm text-slate-700 hover:bg-slate-50 border-none bg-transparent cursor-pointer transition-colors" onClick={handleGenerateJD}>
                                                        Generate JD with AI
                                                    </button>
                                                    <button className="block w-full text-left px-4 py-3 text-sm text-slate-700 hover:bg-slate-50 border-none bg-transparent cursor-pointer transition-colors" onClick={handleUploadJD}>
                                                        Upload JD
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                <div>
                                    <JobsTable
                                        selectedCompany={selectedCompany}
                                        onJobSelect={handleJobSelect}
                                        setSelectedJob={setSelectedJob}
                                        setActiveMain={setActiveMain}
                                        companyEmail={companyEmail}
                                    />
                                </div>
                        </div>
            </div>
        </>
    );
}

export default AllJob;
